export default {"src":"/polygon/_next/static/media/blockchain-mobile.958c85fd.svg","height":17,"width":17};